export const isProduction = process.env.REACT_APP_BUILD_TYPE === 'production';
export const isStaging = process.env.REACT_APP_BUILD_TYPE === 'staging';

let baseUrl = 'https://api.getset4education.co.uk/api/v1';
let domain = 'getset4education.co.uk';
if (!isProduction) {
  baseUrl =
    'https://getset4pe-getset4education-customer-v1.api.avamae.co.uk/api/v1';
  domain = '.avamae.co.uk';
}

export const STOPLIGHT_BASE_URL =
  'https://stoplight.io/mocks/avamae/getset4pe-cloud-web-getset4education-customer-v1';
export const BASE_URL = baseUrl;
export const DOMAIN = domain;

export const endpoints = {
  auth: {
    login: `${BASE_URL}/publicrole/authmodule/login`,
    authLogin: `${BASE_URL}/publicrole/authmodule/autologin`,
    refreshAccessToken: `${BASE_URL}/publicrole/authmodule/refreshaccesstoken`,
    logout: `${BASE_URL}/publicrole/authmodule/logout`,
    createPassword: `${BASE_URL}/publicrole/authmodule/createpassword`,
    user: `${BASE_URL}/userrole/clientsmodule/listclients`,
  },
  public: {
    navigation: {
      headerLinks: `${BASE_URL}/publicrole/navigationmodule/headerlinks`,
      footerLinks: `${BASE_URL}/publicrole/navigationmodule/footerlinks`,
    },
    subscription: {
      getSubscriptions: `${BASE_URL}/publicrole/subscriptionsmodule/getsubscriptions`,
      getSubscriptionsV2: `${BASE_URL}/publicrole/subscriptionsmodule/getsubscriptions_v2`,
      getSubscriptionsWithPromocode: `${BASE_URL}/publicrole/subscriptionsmodule/getsubscriptionswithpromocode`,
      getSubscriptionsWithPromocodeV2: `${BASE_URL}/publicrole/subscriptionsmodule/getsubscriptionswithpromocode_v2`,
      validateSchoolInfo: `${BASE_URL}/publicrole/subscriptionsmodule/validateschoolinfo`,
      createsSchoolUser: `${BASE_URL}/publicrole/subscriptionsmodule/createsschooluser`,
      createsSchoolUserFreeTrial: `${BASE_URL}/publicrole/subscriptionsmodule/createsschooluserfreetrial`,
      subscribeByInvoice: `${BASE_URL}/publicrole/subscriptionsmodule/subscribebyinvoice`,
      /*
      example payload:
      {
  "registrationToken": "string",
  "poNumber": "string",
  "quotesId": 0,
  "expectedGrossAmount": 0,
  "financeEmail": "string",
  "packagePromos": [
    {
      "packagesId": 0,
      "promoCode": "string"
    }
  ]
}
      */
      subscribeByCard: `${BASE_URL}/publicrole/subscriptionsmodule/subscribebycard`,
      /*
      Example payload:
      {
  "registrationToken": "string",
  "poNumber": "string",
  "quotesId": 0,
  "expectedGrossAmount": 0,
  "nameOnCard": "string",
  "cardEndDigits": "string",
  "expiryDate": "string",
  "packagePromos": [
    {
      "packagesId": 0,
      "promoCode": "string"
    }
  ],
  "stripeCardID": "string",
  "stripeToken": "string",
  "financeEmail": "string"
}
      */
      updateAfter3DSecure: `${BASE_URL}/publicrole/subscriptionsmodule/updateafter3dsecure`,
      /*{
  "registrationToken": "string",
  "tid": 0,
  "stripePaymentIntentID": "string",
  "stripePaymentIntentID1": "string",
  "stripeChargeResponse": "string",
  "stripeChargeStatus": "string",
  "stripePaymentIntentStatus": "string",
  "stripeReceiptUrl": "string",
  "bPaid": true,
  "purchaseHistoryStatusType": "string",
  "packageIDs": [
    0
  ]
} */
      getSubscriptionsFreeTrial: `${BASE_URL}/publicrole/subscriptionsmodule/getsubscriptionsFreeTrial`,
      subscribeFreeTrial: `${BASE_URL}/publicrole/subscriptionsmodule/subscribefreetrial`,
      getPriceSummary: `${BASE_URL}/publicrole/subscriptionsmodule/getpricesummary`,
      getPublicPriceSummary: `${BASE_URL}/publicrole/subscriptionsmodule/pricing`,
      getSchoolPriceSummary: `${BASE_URL}/schoolrole/subscriptionsmodule/pricing`,
      getFreeTrialQuestionsInfo: `${BASE_URL}/publicrole/subscriptionsmodule/getfreetrialquestionsinfo`,
      searchUrn: `${BASE_URL}/publicrole/subscriptionsmodule/searchurn`,
      validateSchoolSize: `${BASE_URL}/publicrole/subscriptionsmodule/validateschoolsize`,
      validateVatNumber: `${BASE_URL}/publicrole/subscriptionsmodule/validatevatnumber`,
      getSubscriptionQuestionsInfo: `${BASE_URL}/publicrole/subscriptionsmodule/getsubscriptionquestionsinfo`,
      sendQuoteEmail: `${BASE_URL}/publicrole/subscriptionsmodule/sendquoteemail`,
      getSubscriptionTypesAndPrices: `${BASE_URL}/publicrole/subscriptionsmodule/getsubscriptiontypesandprices`,
      getQuoteStatus: `${BASE_URL}/publicrole/subscriptionsmodule/getquotedetails`,
      saveQoute: `${BASE_URL}/publicrole/subscriptionsmodule/savequote`,
      /*
      Given a promo code, returns the PackagesIds it's valid for.
      Validation messages: Required, Maximum length exceeded, Invalid_PromoCode.
      Example response:
      { "status": "1", "errors": [], "id": 0, "details": { "packagesIds": [0] } }
      */
      checkPromoCode: `${BASE_URL}/publicrole/subscriptionsmodule/checkpromocode`,
    },
    countries: `${BASE_URL}/publicrole/homemodule/countries`,
  },
  forgottenPassword: {
    requestPasswordReset: `${BASE_URL}/publicrole/forgottenpasswordmodule/requestpasswordreset`,
    resetPassword: `${BASE_URL}/publicrole/forgottenpasswordmodule/resetpassword`,
  },
  dashboard: {
    list: `${BASE_URL}/schoolrole/dashboardmodule/dashboard`,
    availablePages: `${BASE_URL}/schoolrole/dashboardmodule/availablepages`,
    autoLoginToken: `${BASE_URL}/schoolrole/dashboardmodule/autologintoken`,
    restartTrial: `${BASE_URL}/schoolrole/dashboardmodule/restart-trial`,
  },
  subscriptions: {
    list: `${BASE_URL}/schoolrole/subscriptionsmodule/subscriptions`,
    subscribebyinvoice: `${BASE_URL}/schoolrole/subscriptionsmodule/subscribebyinvoice`,
    subscribeByCard: `${BASE_URL}/schoolrole/subscriptionsmodule/subscribebycard`,
    updatAfter3DSecure: `${BASE_URL}/schoolrole/subscriptionsmodule/updateafter3dsecure`,
    getSchoolInfo: `${BASE_URL}/schoolrole/subscriptionsmodule/getschoolinfo`,
    updateSchoolInfo: `${BASE_URL}/schoolrole/subscriptionsmodule/updateschoolinfo`,
    getSchoolUsers: `${BASE_URL}/schoolrole/subscriptionsmodule/getschoolusers`,
    updateSchoolUserAccess: `${BASE_URL}/schoolrole/subscriptionsmodule/updateschooluseraccess`,
    renewByInvoice: `${BASE_URL}/schoolrole/subscriptionsmodule/renewbyinvoice`,
    renewByCard: `${BASE_URL}/schoolrole/subscriptionsmodule/renewbycard`,
    updateAfter3DSecureRenew: `${BASE_URL}/schoolrole/subscriptionsmodule/updateafter3dsecureRenew`,
    getSubscriptionsFreeTrial: `${BASE_URL}/schoolrole/subscriptionsmodule/getsubscriptionsFreeTrial`,
    subscribeFreeTrial: `${BASE_URL}/schoolrole/subscriptionsmodule/subscribefreetrial`,
    autoRenewal: `${BASE_URL}/schoolrole/subscriptionsmodule/setautorenewal`,
    setrenewalpackages: `${BASE_URL}/schoolrole/subscriptionsmodule/setrenewalpackages`,
    /* As the public one, but scoped to the signed-in school, so it also refuses a code this
    account has already used: Invalid_PromoCode_NotStarted/_Expired/_UsedAlready. */
    checkPromoCode: `${BASE_URL}/schoolrole/subscriptionsmodule/checkpromocode`,
    getRenewalPromoCode: `${BASE_URL}/schoolrole/subscriptionsmodule/getrenewalpromocode`,
    setRenewalPromoCode: `${BASE_URL}/schoolrole/subscriptionsmodule/setrenewalpromocode`,
    options: `${BASE_URL}/schoolrole/subscriptionsmodule/options`,
  },
  profile: {
    profileDetails: `${BASE_URL}/schoolrole/profilemodule/profile`,
    updateemailpreferences: `${BASE_URL}/schoolrole/profilemodule/updateemailpreferences`,
    updateprofile: `${BASE_URL}/schoolrole/profilemodule/updateprofile`,
    mfaChallenge: `${BASE_URL}/schoolrole/profilemodule/mfa/challenge`,
    mfaRequestTotpQrCode: `${BASE_URL}/schoolrole/profilemodule/mfa/requesttotpqrcode`,
    mfaVerify: `${BASE_URL}/schoolrole/profilemodule/mfa/verify`,
    mfaEnableChallengeType: `${BASE_URL}/schoolrole/profilemodule/mfa/enablechallengetype`,
    mfaDisableChallengeType: `${BASE_URL}/schoolrole/profilemodule/mfa/disablechallengetype`,
  },
  manageUsers: {
    list: `${BASE_URL}/schoolrole/usermanagementmodule/list`,
    addUser: `${BASE_URL}/schoolrole/usermanagementmodule/adduser`,
    updateuser: `${BASE_URL}/schoolrole/usermanagementmodule/updateuser`,
    updateaccesspermissions: `${BASE_URL}/schoolrole/usermanagementmodule/updateaccesspermissions`,
    viewuser: `${BASE_URL}/schoolrole/usermanagementmodule/viewuser`,
    deleteuser: `${BASE_URL}/schoolrole/usermanagementmodule/deleteuser`,
    resetuserpassword: `${BASE_URL}/schoolrole/usermanagementmodule/resetuserpassword`,
    downloadUserTemplateCSV: `${BASE_URL}/schoolrole/usermanagementmodule/templatedownloadcsv`,
    downloadUserListCSV: `${BASE_URL}/schoolrole/usermanagementmodule/listdownloadcsv`,
    uploadUserListCSV: `${BASE_URL}/schoolrole/usermanagementmodule/uploadcsv`,
  },
  invoices: {
    list: `${BASE_URL}/schoolrole/invoicesmodule/list`,
    viewInvoice: `${BASE_URL}/schoolrole/invoicesmodule/viewinvoice`,
    downloadInvoice: `${BASE_URL}/schoolrole/invoicesmodule/downloadinvoice`,
  },
  manageschool: {
    getSchoolDetails: `${BASE_URL}/schoolrole/schoolmanagementmodule/school`,
    updateSchoolDetails: `${BASE_URL}/schoolrole/schoolmanagementmodule/updateschool`,
    updateArchivingDate: `${BASE_URL}/schoolrole/schoolmanagementmodule/updatearchivingdate`,
    archiveNow: `${BASE_URL}/schoolrole/schoolmanagementmodule/archivenow`,
    mfaRequestStatus: `${BASE_URL}/schoolrole/schoolmanagementmodule/mfarequeststatus`,
    requestMfaChange: `${BASE_URL}/schoolrole/schoolmanagementmodule/requestmfachange`,
    ipWhitelist: `${BASE_URL}/schoolrole/schoolmanagementmodule/ipwhitelist`,
    createIpWhitelistEntry: `${BASE_URL}/schoolrole/schoolmanagementmodule/createipwhitelistentry`,
    deleteIpWhitelistEntry: `${BASE_URL}/schoolrole/schoolmanagementmodule/deleteipwhitelistentry`,
  },
  subscribe: {
    subscriptionContent: `${STOPLIGHT_BASE_URL}/1302880/subscriptionsmodule/packages`,
  },
  wondeIntegration: {
    checkLinkStatus: `${BASE_URL}/schoolrole/wondeintegrationmodule/checkaccess`,
    getSchoolLinkList: `${BASE_URL}/schoolrole/wondeintegrationmodule/schools`,
    requestAccess: `${BASE_URL}/schoolrole/wondeintegrationmodule/requestaccess`,
    syncData: `${BASE_URL}/schoolrole/wondeintegrationmodule/syncdata`,
    compareAcademicYears: `${BASE_URL}/schoolrole/wondeintegrationmodule/compareacademicyears`,
    syncMatchedData: `${BASE_URL}/schoolrole/wondeintegrationmodule/syncmatcheddata`,
    classStep1List: `${BASE_URL}/schoolrole/wondeintegrationmodule/syncclasses_namematch_list`,
    classStep1NameMatch: `${BASE_URL}/schoolrole/wondeintegrationmodule/syncclasses_namematch`,
    classStep2ManualMatchList: `${BASE_URL}/schoolrole/wondeintegrationmodule/syncclasses_manualmatch_list`,
    classStep2ManualMatch: `${BASE_URL}/schoolrole/wondeintegrationmodule/syncclasses_manualmatch`,
    classStep3List: `${BASE_URL}/schoolrole/wondeintegrationmodule/syncclasses_unmatchedwondeclasses_list`,
    classStep3UnmatchedWondeClasses: `${BASE_URL}/schoolrole/wondeintegrationmodule/syncclasses_unmatchedwondeclasses`,
    classStep4List: `${BASE_URL}/schoolrole/wondeintegrationmodule/syncclasses_unmatchedclasses_list`,
    classStep4UnmatchedClassesDelete: `${BASE_URL}/schoolrole/wondeintegrationmodule/syncclasses_unmatchedclasses_delete`,
    pupilStep1List: `${BASE_URL}/schoolrole/wondeintegrationmodule/syncpupils_namematch_list`,
    pupilStep1NameMatch: `${BASE_URL}/schoolrole/wondeintegrationmodule/syncpupils_namematch`,
    pupilStep2ManualMatchList: `${BASE_URL}/schoolrole/wondeintegrationmodule/syncpupils_manualmatch_list`,
    pupilStep2ManualMatch: `${BASE_URL}/schoolrole/wondeintegrationmodule/syncpupils_manualmatch`,
    pupilStep3List: `${BASE_URL}/schoolrole/wondeintegrationmodule/syncpupils_unmatchedwondepupils_list`,
    pupilStep3UnmatchedWondeClasses: `${BASE_URL}/schoolrole/wondeintegrationmodule/syncpupils_unmatchedwondepupils`,
    pupilStep4List: `${BASE_URL}/schoolrole/wondeintegrationmodule/syncpupils_unmatchedpupils_list`,
    pupilStep4UnmatchedClassesDelete: `${BASE_URL}/schoolrole/wondeintegrationmodule/syncpupils_unmatchedpupils_delete`,
    prevMatchedRecordsClass: `${BASE_URL}/schoolrole/wondeintegrationmodule/matchedclasses`,
    prevMatchedRecordsPupil: `${BASE_URL}/schoolrole/wondeintegrationmodule/matchedpupil`,
  },
  myDocuments: {
    list: `${BASE_URL}/schoolrole/documentsmodule/list`,
    folderStructure: `${BASE_URL}/schoolrole/documentsmodule/folderstructure`,
    createFile: `${BASE_URL}/schoolrole/documentsmodule/createdocument`,
    updateFile: `${BASE_URL}/schoolrole/documentsmodule/updatedocument`,
    viewFile: `${BASE_URL}/schoolrole/documentsmodule/viewdocument`,
    deleteFile: `${BASE_URL}/schoolrole/documentsmodule/deletedocuments`,
    createFolder: `${BASE_URL}/schoolrole/documentsmodule/createfolder`,
    updateFolder: `${BASE_URL}/schoolrole/documentsmodule/updatefolder`,
    deleteFolders: `${BASE_URL}/schoolrole/documentsmodule/deletefolders`,
    moveFile: `${BASE_URL}/schoolrole/documentsmodule/movefile`,
    moveFolder: `${BASE_URL}/schoolrole/documentsmodule/movefolder`,
  },
};
